export const STYLES_LIST = ['Arsty', 'Chic', 'Hip Hop', 'Rocker'];
